import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { CRAWL_READ_ROLES } from "@/features/crawl-dashboard/crawl-roles"

export const Route = createFileRoute("/crawl")({
	component: CrawlLayout,
})

function CrawlLayout() {
	const navigate = useNavigate()
	const { hasAnyRole } = useAdminRolesContext()
	const canRead = hasAnyRole([...CRAWL_READ_ROLES])

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])

	if (!canRead) return null
	return <Outlet />
}
